module.exports = __webpack_public_path__ + "img/data-item2-1.6cf8f68.png";